import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';
import { Issues } from '~/features/issues/Issues';
import { z } from 'zod';

const issuesSearchSchema = z.object({
  issueId: z.string().optional(),
});

export const Route = createFileRoute('/_auth/_appLayout/issues')({
  component: Issues,
  errorComponent: NestedRouteErrorBoundary,
  validateSearch: zodValidator(issuesSearchSchema),
});
